import { useFetchData } from 'hooks/useFetchData';
import { getLanguages } from 'backend/additionalInformation';
import React, { useEffect, useReducer } from 'react';
import { TLanguageIDs, ICreateWording } from 'types';
import { addWordingsReducer } from './addWordingsReducer';
import { addWordingsInitialState, TTypeOfModalWindow, AddWordingsContext } from './addWordingsContext';
import { AddWordingsActionsTypes } from './addWordingsActions';

const AddWordingsState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(addWordingsReducer, addWordingsInitialState);
	const { response } = useFetchData(getLanguages);

	useEffect(() => {
		if (response) {
			dispatch({
				type: AddWordingsActionsTypes.SET_FETCHED_LANGUAGES,
				payload: {
					fetchedLanguages: response.data.languages,
				},
			});

			dispatch({
				type: AddWordingsActionsTypes.CHANGE_TRANSLATIONS,
				payload: {
					translations: response.data.languages.map((el) => ({
						label: '',
						value: '',
						languageId: el.id,
					})),
				},
			});
		}
	}, [response]);

	const setIDCategory = (value: string) => {
		dispatch({
			type: AddWordingsActionsTypes.SET_ID_CATEGORY,
			payload: {
				IDSelectedCategory: value,
			},
		});
	};

	const changeKey = (value: string) => {
		dispatch({
			type: AddWordingsActionsTypes.CHANGE_KEY,
			payload: {
				key: value,
			},
		});
	};

	const changeLabels = (languageId: TLanguageIDs, value: string) => {
		const updatedTranslations = state.translations.map((el) =>
			el.languageId === languageId ? { ...el, label: value } : el,
		);
		dispatch({
			type: AddWordingsActionsTypes.CHANGE_TRANSLATIONS,
			payload: {
				translations: updatedTranslations,
			},
		});
	};

	const changeValues = (languageId: TLanguageIDs, value: string) => {
		const updatedTranslations = state.translations.map((el) =>
			el.languageId === languageId ? { ...el, value } : el,
		);
		dispatch({
			type: AddWordingsActionsTypes.CHANGE_TRANSLATIONS,
			payload: {
				translations: updatedTranslations,
			},
		});
	};

	const setDataForSubmit = (value: ICreateWording | null) => {
		dispatch({
			type: AddWordingsActionsTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	};

	const resetFields = () => {
		dispatch({
			type: AddWordingsActionsTypes.RESET_FIELDS,
		});
	};

	const changeTypeOfModalWindow = (value: TTypeOfModalWindow) => {
		dispatch({
			type: AddWordingsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	};

	return (
		<AddWordingsContext.Provider
			value={{
				setIDCategory,
				changeKey,
				changeLabels,
				changeValues,
				setDataForSubmit,
				resetFields,
				changeTypeOfModalWindow,
				IDSelectedCategory: state.IDSelectedCategory,
				key: state.key,
				fetchedLanguages: state.fetchedLanguages,
				translations: state.translations,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</AddWordingsContext.Provider>
	);
};

export default AddWordingsState;
